interface EnvInfo {
	path: string;
	isIframe: boolean;
	parentPageUrl: string;
	userAgent: string;
}

export default class EnvInfoManager {
	private path: string;
	private isIframe: boolean;
	private parentPageUrl: string;
	private userAgent: string;
	constructor () {
		this.path = this.getPath();
		this.isIframe = window !== window.top;
		this.parentPageUrl = this.getParentPageUrl();
		this.userAgent = window.navigator && window.navigator.userAgent;
	}
	/**
	 * 获取页面路径信息
	 */
	getPath (): string {
		if (!window || !window.location) return '';
		return `${window.location.hostname}${window.location.pathname}`;
	}
	/**
	 * 获取父级页面地址，仅在当前页面为 iframe 时有值
	 */
	getParentPageUrl (): string {
		if (!this.isIframe) return '';
		let referrer = document && document.referrer;
		let url = window && window.location && window.location.href;
		if (referrer === url) return '';
		return referrer;
	}
	/**
	 * 获取当前页面 url 信息
	 */
	getEnvInfo (): EnvInfo {
		return {
			path: this.path,
			isIframe: this.isIframe,
			parentPageUrl: this.parentPageUrl,
			userAgent: this.userAgent
		};
	}
}
